import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { mediaQuery } from 'lib/styledSystem';
import { Flex, Box, Icon, NakedButton } from 'roo-ui/components';

export const List = styled.ul`
  margin: 0;
  padding: 0;
  margin-top: -${themeGet('space.3')};

  ${mediaQuery.minWidth.sm} {
    display: flex;
    flex-wrap: wrap;
  }
`;

export const ListItem = styled.li`
  list-style-type: none;
  padding: ${themeGet('space.3')} 0;
  margin: 0;
  border-bottom: 1px solid ${themeGet('colors.greys.alto')};

  ${mediaQuery.minWidth.sm} {
    flex-basis: 50%;
  }
`;

export const ViewAllButton = styled(NakedButton)`
  color: ${themeGet('colors.ui.link')};
  text-decoration: underline;
  margin-top: ${themeGet('space.3')};
`;

export const Flag = ({ icon, children }) => {
  return (
    <Flex mb={2}>
      <Box flex="0 1 32px">{icon && <Icon name={icon} mr="2" />}</Box>
      {children}
    </Flex>
  );
};

Flag.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Flag.defaultProps = {
  icon: '',
};
